export const loginRoute = {
  path: 'login',
  url: '/login',
  loadChildren: () => import('../../../shell/login/login.module').then(m => m.LoginModule),
};
